/* Premium access, the same rule as the server (services/premium.js): the
   isPremium flag (programs, memberships, admin), or a dated grant still
   running (premiumUntil: a Nubod challenge round). */
export const hasPremium = (user, now = Date.now()) =>
  !!user &&
  (user.isPremium === true ||
    (!!user.premiumUntil && new Date(user.premiumUntil).getTime() > now));
